export const environment = {
  production: false,
  mapboxPublickAccessToken:
    "pk.eyJ1IjoibGFuZGlxLWRldiIsImEiOiJjbWpkN2pweDQwM2l0M2NxNWtndmJ0ZWVjIn0.VoQFrV5bk4484QxJVtkaOw", // Replace with your Mapbox access token
  maintenanceMode: false,
  maintenanceTitle: "Under Maintenance",
  maintenanceMessage:
    "The Web Application is temporarily unavailable. Please check back shortly. If the issue persists, please contact us: irrigationmanagement@landiq.com",
  maintenanceEta: "",
  waterYearTimezone: "America/Los_Angeles", // california water year
};
